const LandPageTypes = {
    LOGIN: 'LOGIN',
    ADMIN: 'ADMIN',
    LOTTERY: 'LOTTERY',
};

export default LandPageTypes;



// WEBPACK FOOTER //
// src/views/LandPageTypes.js